
import ControllerPost from 'Controllers/ControllerPost'
export default {
  components: {
    ControllerPost,
  },
}
